/* tslint:disable */

declare var Object: any;
export interface StatisticInterface {
  "id": string;
  "TotalScreens": number;
  "TotalVideos": number;
  "TotalImages": number;
  "TotalFeeds": number;
  "TotalUpdates": number;
  "TotalVideoFileSize": number;
  "TotalImageFileSize": number;
  "TotalAudioFileSize": number;
  "Metadata"?: any;
  "Categories"?: string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
}

export class Statistic implements StatisticInterface {
  "id": string;
  "TotalScreens": number;
  "TotalVideos": number;
  "TotalImages": number;
  "TotalFeeds": number;
  "TotalUpdates": number;
  "TotalVideoFileSize": number;
  "TotalImageFileSize": number;
  "TotalAudioFileSize": number;
  "Metadata": any;
  "Categories": string;
  "createdByIp": string;
  "lastUpdatedByIp": string;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: StatisticInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Statistic`.
   */
  public static getModelName() {
    return "Statistic";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Statistic for dynamic purposes.
  **/
  public static factory(data: StatisticInterface): Statistic{
    return new Statistic(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Statistic',
      plural: 'Statistics',
      path: 'Statistics',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
        "TotalScreens": {
          name: 'TotalScreens',
          type: 'number',
          default: 0
        },
        "TotalVideos": {
          name: 'TotalVideos',
          type: 'number',
          default: 0
        },
        "TotalImages": {
          name: 'TotalImages',
          type: 'number',
          default: 0
        },
        "TotalFeeds": {
          name: 'TotalFeeds',
          type: 'number',
          default: 0
        },
        "TotalUpdates": {
          name: 'TotalUpdates',
          type: 'number',
          default: 0
        },
        "TotalVideoFileSize": {
          name: 'TotalVideoFileSize',
          type: 'number',
          default: 0
        },
        "TotalImageFileSize": {
          name: 'TotalImageFileSize',
          type: 'number',
          default: 0
        },
        "TotalAudioFileSize": {
          name: 'TotalAudioFileSize',
          type: 'number',
          default: 0
        },
        "Metadata": {
          name: 'Metadata',
          type: 'any'
        },
        "Categories": {
          name: 'Categories',
          type: 'string'
        },
        "createdByIp": {
          name: 'createdByIp',
          type: 'string'
        },
        "lastUpdatedByIp": {
          name: 'lastUpdatedByIp',
          type: 'string'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Statistic.ts